import React from 'react'
import { Form, InputNumber, Typography } from 'antd'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormInputNumber = ({
  name,
  label,
  rules,
  labelAbove,
  showColon,
  ...rest
}) => (
  <Form.Item
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    fieldKey={name}
    name={name}
    label={
      <Typography.Text>{formatFormLabel(label, showColon)}</Typography.Text>
    }
    rules={rules}
  >
    <InputNumber {...rest} />
  </Form.Item>
)

FormInputNumber.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  showColon: PropTypes.bool,
}

FormInputNumber.defaultProps = {
  label: '',
  rules: undefined,
  labelAbove: false,
  showColon: true,
}

export default FormInputNumber
